import { API_COMMENTS } from "../constants/api";

export default (axios) => ({
    getComments(company_id) {
        return axios
            .get(`${API_COMMENTS}/company/${company_id}?per_page=300`)
            .then(({ data }) => {
                return data.data;
            });
    },

    createComment(params) {
      const formData = new FormData();
      formData.append('company_id', params.company_id)
      formData.append('comment', params.comment);
      formData.append('bookmarked', params.bookmarked ? params.bookmarked : false);
      if (params.parent_comment_id) {
        formData.append('parent_comment_id', params.parent_comment_id);
      }
      formData.append('files', [])
      for( var i = 0; i < params.files.length; i++ ){
        let file = params.files[i];
        formData.append('files[' + i + ']', file);
      }

      return axios
            .post(API_COMMENTS, formData)
            .then(({ data }) => {
                return data;
            });
    },

    async removeComment(id) {
        await axios.delete(`${API_COMMENTS}/${id}`);
    },

    async makeBookmarked(params) {
        await axios.post(`${API_COMMENTS}/make-bookmarked`, params);
    },

    editComment(id, comment) {
        return axios
            .put(`${API_COMMENTS}/${id}`, {
                comment: comment,
            })
            .then(({ data }) => {
                return data.data;
            });
    },
});
